import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import CreateTrackingList from './CreateTrackingList';
import ViewTrackingList from './ViewTrackingList';
import { SiteTitle } from "../SiteTitle";


function TrackBackground() {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <SiteTitle />

            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="建立追蹤清單" value="1" />
                        <Tab label="查看追蹤清單" value="2" />
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <CreateTrackingList />
                </TabPanel>
                <TabPanel value="2">
                    <ViewTrackingList />
                </TabPanel>
            </TabContext>
        </div>
    );
}

export default TrackBackground;
